import React from "react";
import { ReactComponent as Top } from "../statics/icons/top.svg";
import { ReactComponent as Middle } from "../statics/icons/middle.svg";
import { ReactComponent as Ground } from "../statics/icons/ground.svg";
import { TileModel } from "./tile";


export enum FloorId {
    top = "TOP",
    middle = "MIDDLE",
    ground = "GROUND"
}

export const Floor: TileModel[] = [
    {
        id: FloorId.ground,
        displayName: "Parter",
        icon: <Ground className="icon-svg-color" />
    },
    {
        id: FloorId.middle,
        displayName: "Pośrednie",
        icon: <Middle className="icon-svg-color" />
    },
    {
        id: FloorId.top,
        displayName: "Ostatnie",
        icon: <Top className="icon-svg-color" />
    }
];
